import { css, useTheme } from "@emotion/react";
import { Field as DefaultField } from "formik";

import {
  parseStyle,
  useThemeProps,
  handleComponentsProp,
  MaybeFragment,
} from "../../wsui/base";

import DefaultFormFieldDescription from "./FormFieldDescription.jsx";
import DefaultFormFieldError from "./FormFieldError.jsx";
import DefaultFormFieldLabel from "./FormFieldLabel.jsx";
import DefaultFormFieldWrapper from "./FormFieldWrapper.jsx";

export default function FormTextField(props) {
  props = useThemeProps({ props, name: "FormTextField" });
  props = useThemeProps({ props, name: "FormField" });
  let {
    inputProps = {},
    placeholder,
    components,
    rowGap = [1, 2],
    rows,
    ...restProps
  } = props;
  let {
    Field,
    FormFieldDescription,
    FormFieldError,
    FormFieldLabel,
    FormFieldWrapper,
  } = handleComponentsProp(components, {
    Field: DefaultField,
    FormFieldDescription: DefaultFormFieldDescription,
    FormFieldError: DefaultFormFieldError,
    FormFieldLabel: DefaultFormFieldLabel,
    FormFieldWrapper: DefaultFormFieldWrapper,
  });
  const theme = useTheme();

  let {
    style,
    focusStyle,
    hoverStyle,
    borderRadius = 1,
    paddingBlock = 3,
    paddingInline = 3,
    ...restInputProps
  } = inputProps;

  return (
    <FormFieldWrapper
      // className={clsx(styles.component, className)}
      css={css`
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: ${theme.getLength(rowGap)};
      `}
      {...restProps}
    >
      {({ name, controlProps, wrapperProps, id }) => (
        <MaybeFragment {...wrapperProps}>
          <FormFieldLabel
          // className={styles.label}
          />
          <FormFieldDescription
          // className={styles.description}
          />
          <div
          // className={styles.control}
          >
            <Field
              as="textarea"
              // className={styles.input}
              name={name}
              rows={rows}
              css={css`
                width: 100%;
                padding-block: ${theme.getLength(paddingBlock)};
                padding-inline: ${theme.getLength(paddingInline)};
                box-sizing: border-box;
                border-radius: ${theme.getLength(borderRadius)};
                border: 1px solid ${theme.getColor(`border.300`)};
                box-shadow: none;
                font: inherit;
                color: inherit;
                ${parseStyle(style, theme)}
                &:focus {
                  ${parseStyle(focusStyle, theme)}
                }
                &:hover {
                  ${parseStyle(hoverStyle, theme)}
                }
              `}
              id={id}
              placeholder={placeholder}
              {...controlProps}
              {...restInputProps}
            />
          </div>
          <FormFieldError
          // className={styles.error}
          />
        </MaybeFragment>
      )}
    </FormFieldWrapper>
  );
}
